import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useUpdateSettings = () => {
  return useMutation({
    mutationFn: (data: any) => api.referral.updateSettings(data)
  })
}
